import { PieChart, Pie, Tooltip, ResponsiveContainer, BarChart, YAxis, XAxis, Bar, Cell } from "recharts"
import PropTypes from 'prop-types'
import { Card, CardContent, Typography, Grid, useMediaQuery } from "@mui/material"
import { useTheme } from "@mui/material/styles";

import { capitalize, colors, darkenColor } from '../../utils'


const CraftChart = ({ chartData, onDeckClick }) => {
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

    const handleDeckClick = (data) => onDeckClick(data.craft.toLowerCase(), data.name)

    return (
        <Card sx={{ mb: 3 }}>
            <CardContent>
                <Typography variant='h5' sx={{ mb: 2 }}>{ } {capitalize(chartData[0].craft)}craft Stats</Typography>
                <Grid container>
                    <Grid item xs={12} md={3}>
                        <Typography variant='h6' align='center'>Deck Usage</Typography>
                        <ResponsiveContainer width='100%' height={300} >
                            <PieChart width={300} height={300}>
                                <Tooltip />
                                <Pie data={chartData} nameKey='name' dataKey='value'>
                                    {chartData.map((entry, index) => <Cell key={entry.name} fill={darkenColor(colors[entry.craft.toLowerCase()][0], index * -20)} />)}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </Grid>
                    <Grid item xs={12} md={9}>
                        <Typography variant='h6' align='center' gutterBottom>Deck Wins/Losses</Typography>
                        <ResponsiveContainer width='100%' height={300}>
                            <BarChart margin={{ left: 20 }} data={chartData}>
                                <YAxis type='number' domain={[0, chartData.value]} hide />
                                <XAxis type='category' dataKey='name' interval={0} tick={isSmallScreen ? false : { fontSize: '0.9em' }} />
                                <Tooltip />
                                <Bar dataKey='wins' stackId='a' onMouseDown={handleDeckClick} >
                                    {chartData.map((entry) => <Cell cursor='pointer' key={`${entry.name}-win`} fill={colors[entry.craft.toLowerCase()][0]} />)}
                                </Bar>
                                <Bar dataKey='losses' stackId='a' onMouseDown={handleDeckClick} >
                                    {chartData.map((entry) => <Cell cursor='pointer' key={`${entry.name}-lose`} fill={colors[entry.craft.toLowerCase()][1]} />)}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

CraftChart.propTypes = {
    chartData: PropTypes.array,
    onDeckClick: PropTypes.func.isRequired
}

export default CraftChart